"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = exports.Radio = exports.RadioGroup = exports.Checkbox = exports.CheckboxGroup = exports.MultiSelect = exports.Select = exports.RangeDatePicker = exports.DatePicker = exports.TextArea = exports.NumberInput = exports.PasswordInput = exports.TextInput = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var formstate_x_1 = require("formstate-x");
var base = tslib_1.__importStar(require(".."));
var FormItem_1 = require("./FormItem");
function useFieldState(_a, render) {
    var state = _a.state, restProps = tslib_1.__rest(_a, ["state"]);
    FormItem_1.useStateInFormItem(state);
    return (react_1.default.createElement(mobx_react_1.Observer, { render: function () {
            var inputBindings = formstate_x_1.bindInput(state);
            var inputProps = tslib_1.__assign(tslib_1.__assign({}, restProps), inputBindings);
            return render(inputProps);
        } }));
}
function useFieldStateForCommonCheckbox(_a, render) {
    var state = _a.state, restProps = tslib_1.__rest(_a, ["state"]);
    FormItem_1.useStateInFormItem(state);
    return (react_1.default.createElement(mobx_react_1.Observer, { render: function () {
            var inputProps = tslib_1.__assign({}, restProps);
            if (state != null) {
                var inputBindings = formstate_x_1.bindInput(state);
                inputProps.checked = inputBindings.value;
                inputProps.onChange = inputBindings.onChange;
            }
            return render(inputProps);
        } }));
}
function TextInput(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.TextInput, tslib_1.__assign({}, inputProps))); });
}
exports.TextInput = TextInput;
function PasswordInput(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.PasswordInput, tslib_1.__assign({}, inputProps))); });
}
exports.PasswordInput = PasswordInput;
function NumberInput(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.NumberInput, tslib_1.__assign({}, inputProps))); });
}
exports.NumberInput = NumberInput;
function TextArea(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.TextArea, tslib_1.__assign({}, inputProps))); });
}
exports.TextArea = TextArea;
function DatePicker(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.DatePicker, tslib_1.__assign({}, inputProps))); });
}
exports.DatePicker = DatePicker;
function RangeDatePicker(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.RangeDatePicker, tslib_1.__assign({}, inputProps))); });
}
exports.RangeDatePicker = RangeDatePicker;
function Select(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.Select, tslib_1.__assign({}, inputProps))); });
}
exports.Select = Select;
function MultiSelect(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.MultiSelect, tslib_1.__assign({}, inputProps))); });
}
exports.MultiSelect = MultiSelect;
function CheckboxGroup(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.CheckboxGroup, tslib_1.__assign({}, inputProps))); });
}
exports.CheckboxGroup = CheckboxGroup;
function Checkbox(props) {
    return useFieldStateForCommonCheckbox(props, function (inputProps) { return (react_1.default.createElement(base.Checkbox, tslib_1.__assign({}, inputProps))); });
}
exports.Checkbox = Checkbox;
function RadioGroup(props) {
    return useFieldState(props, function (inputProps) { return (react_1.default.createElement(base.RadioGroup, tslib_1.__assign({}, inputProps))); });
}
exports.RadioGroup = RadioGroup;
function Radio(props) {
    return useFieldStateForCommonCheckbox(props, function (inputProps) { return (react_1.default.createElement(base.Radio, tslib_1.__assign({}, inputProps))); });
}
exports.Radio = Radio;
function useFieldStateForSwitch(_a, render) {
    var state = _a.state, restProps = tslib_1.__rest(_a, ["state"]);
    FormItem_1.useStateInFormItem(state);
    return (react_1.default.createElement(mobx_react_1.Observer, { render: function () {
            var inputProps = tslib_1.__assign({}, restProps);
            if (state != null) {
                var inputBindings = formstate_x_1.bindInput(state);
                inputProps.checked = inputBindings.value;
                inputProps.onChange = inputBindings.onChange;
            }
            return render(inputProps);
        } }));
}
function Switch(props) {
    return useFieldStateForSwitch(props, function (inputProps) { return (react_1.default.createElement(base.Switch, tslib_1.__assign({}, inputProps))); });
}
exports.Switch = Switch;
//# sourceMappingURL=Input.js.map